import type { ContextAppType } from "@/features/auth/context-app/types/ContextApp"
import type { HabilitationDTO } from "@/features/api/habilitation/dto/habilitation/HabilitationDTO"
export const HabilitationsAdminMode = ['entite', 'contact'] as const
export type HabilitationsAdminMode = typeof HabilitationsAdminMode[number]
export const HabilitationsAdminModeLibelle: Record<HabilitationsAdminMode, string> = {
  entite: 'Entité juridique',
  contact: "Utilisateur"
} as const
export type QueryChangedEventArg = {
  identifiant?: string
  context?: ContextAppType
  mode?: HabilitationsAdminMode
}

export const HabilitationsChangedReason = ['Add', 'Update', 'Delete'] as const
export type HabilitationsChangedReason = typeof HabilitationsChangedReason[number]

export type HabilitationsAdminProps = {
  jwtToken: string
  autoRun?: boolean
  context?: ContextAppType
  contextReadOnly?: boolean
  contextHidden?: boolean
  mode?: HabilitationsAdminMode
  modeReadOnly?: boolean
  modeHidden?: boolean
  identifiant?: string
  itentifiantReadOnly?: boolean
  identifiantHidden?: boolean
}

export type HabilitationsAdminEmits = {
  runStarted: [boolean]
  tokenValidated: [boolean]
  contextChanged: [ContextAppType]
  modeChanged: [HabilitationsAdminMode]
  identifiantChanged: [string?]
  autorisationsChanged: [HabilitationsChangedReason, HabilitationDTO]
  queryChanged: [boolean, QueryChangedEventArg]
}

export type TokenData = {
  clientId: string,
  userId: string,
  email: string,
  username: string,
  jti: string,  // Identifiant unique du jeton
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role": string,
  contextTypeUser: "Externe" | "Interne",
  isImpersonating: "True" | "False",
  exp: number,  // Expiration
  iss: string,  // Fournisseur du jeton
  aud: string,   // Audience du jeton
}
